import { Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HandleMappingApplications, UpdateAssessmentState } from "../Store";
import { deleteAssessment, getAssessments } from "../Store/Thunk";
import { applicationTypeEnum } from "../../../../../Helpers/EnumHelper";
import { UpdateIsArchive, UpdateIsVitrine } from "../../Inventory/Store/Thunk";
import {
  AdminListCard,
  AdminListMain,
  AdminActions,
  AdminButton,
  AdminSwitch,
  ConfirmDeleteButton,
} from "../../../SharedComponents/ListView";

export default function AssessmentList({ isArchiveActive }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const assessmentList = useSelector((state) => state.assessment.assessmentList);

  const HandleUpdateButton = (assess) => {
    dispatch(
      UpdateAssessmentState({
        id: assess.id,
        name: assess.name,
        isB2b: assess.isB2b,
        price: assess.price,
        isUpdateOperation: true,
        selectedApplications: HandleMappingApplications(assess.inventories, assess.tests, assess.surveys),
      })
    );
  };

  const HandleInfoButton = (assessment) => {
    navigate("/info", {
      state: {
        id: assessment.id,
        name: assessment.name,
        applicationType: assessment.applicationType,
        info: {
          id: assessment.id,
          infoTitle: assessment.infoTitle,
          description: assessment.description,
          infoHtml: assessment.infoHtml,
          iconImageName: assessment.iconImageName,
          pdfCoverImageName: assessment.pdfCoverImageName,
          pdfInfoImageName: assessment.pdfInfoImageName,
        },
      },
    });
  };

  const EntityBadges = ({ items, color, labelKey }) =>
    (items || []).map((item) => (
      <Badge key={item.id} bg={color}>
        {item[labelKey]}
      </Badge>
    ));

  return (
    assessmentList &&
    assessmentList.map((assessment, i) => {
      if (!!assessment.isArchive !== isArchiveActive) return null;

      return (
        <AdminListCard
          key={"assess" + i}
          tag={assessment.tag}
          footer={
            <>
              <EntityBadges items={assessment.inventories} color="primary" labelKey="name" />
              <EntityBadges items={assessment.tests} color="secondary" labelKey="name" />
              <EntityBadges items={assessment.surveys} color="warning" labelKey="name" />
              {assessment.companies?.map((company, c) => (
                <span key={"co" + c} className="admin-list-meta ms-2">
                  {company}
                </span>
              ))}
            </>
          }
        >
          <AdminListMain>
            <span className="admin-list-id">{assessment.id}</span>
            <span className="admin-list-title">{assessment.name}</span>
            <span style={{ color: assessment.isB2b ? "#18b26b" : "#dc3545", fontWeight: 700 }}>
              {assessment.price}
            </span>
          </AdminListMain>
          <AdminActions>
            <AdminSwitch
              label={t("vitrine")}
              checked={assessment.isVitrine}
              onChange={(e) =>
                dispatch(
                  UpdateIsVitrine({
                    payload: {
                      applicationType: applicationTypeEnum.Assessment,
                      id: assessment.id,
                      isVitrine: e.target.checked,
                    },
                    callback: getAssessments,
                  })
                )
              }
            />
            <AdminSwitch
              label={t("archive")}
              checked={assessment.isArchive}
              onChange={(e) =>
                dispatch(
                  UpdateIsArchive({
                    payload: {
                      applicationType: applicationTypeEnum.Assessment,
                      id: assessment.id,
                      isArchive: e.target.checked,
                    },
                    callback: getAssessments,
                  })
                )
              }
            />
            <AdminButton onClick={() => HandleInfoButton(assessment)}>{t("infoButtonLabel")}</AdminButton>
            <AdminButton variant="outline" onClick={() => HandleUpdateButton(assessment)}>
              {t("edit")}
            </AdminButton>
            <ConfirmDeleteButton onConfirm={() => dispatch(deleteAssessment({ id: assessment.id }))} />
          </AdminActions>
        </AdminListCard>
      );
    })
  );
}
